var _toConsumableArray = require("/builds/SocialGouv/legi-detect/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/toConsumableArray");

var _defineProperty = require("/builds/SocialGouv/legi-detect/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/defineProperty");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var _require = require("./detect.code"),
    detectCode = _require.detectCode,
    maxCodeWordsCount = _require.maxCodeWordsCount; // poor-man multiline regexps


var SINGLE_ARTICLE = "([LRD])?\\s*" + //           prefix      Article LDR
"[.-\\s*]?" + //                          separator    -
"\\s*" + //                              spaces
"(\\d{1,4}(-\\d+){0,3})\\b"; //          nums        123 123-45 123-45-6 123-45-6-7

var RE_ARTICLE = "(?:art.|article)\\s+" + SINGLE_ARTICLE;
var RE_ARTICLES = "articles\\s+(" + SINGLE_ARTICLE + ")\\s*(a|à|et)\\s+(" + SINGLE_ARTICLE + ")";

var getWords = function getWords(str, count) {
  var startWordIndex = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
  return str.trim().split(" ").slice(startWordIndex, count);
};

var getSubPhraseFromIndex = function getSubPhraseFromIndex(str, index) {
  var wordsCount = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : maxCodeWordsCount;
  return getWords(str.substring(index), wordsCount).join(" ");
};
/* find and normalize multiple article references
 *
 * Articles D523 à L523-2
 * Articles L523-2 et 523-2-3-2
 * Articles D523 et L523-2 du code du commerce
 *
 */


var detectMultiples = function detectMultiples(str, defaultCode) {
  var matches = str.match(new RegExp(RE_ARTICLES, "gi"));
  var startIndex = 0;
  return matches && matches.map(function (match) {
    var parts = match.match(new RegExp(RE_ARTICLES, "i"));
    var articles = ["".concat(parts[2] || "").concat(parts[3]), "".concat(parts[7] || "").concat(parts[8])];
    var indexOfArticles = str.indexOf(match, startIndex);
    var operator = parts[5];
    var codeSearchString = getSubPhraseFromIndex(str, indexOfArticles + match.length);
    startIndex = indexOfArticles + match.length;
    var detectedCode = detectCode(codeSearchString);
    var sourceString = detectedCode ? str.substring(indexOfArticles, indexOfArticles + "".concat(match, " du ").concat(detectedCode.source).length) : str.substring(indexOfArticles, indexOfArticles + match.length);
    var valueString = detectedCode ? "Articles ".concat(articles[0], " ").concat(operator, " ").concat(articles[1], " du ").concat(detectedCode.value) : "Articles ".concat(articles[0], " ").concat(operator, " ").concat(articles[1]);
    var code = detectedCode || defaultCode;

    if (operator.toLowerCase() === "et") {
      var firstArticle = detectSingle("Article ".concat(articles[0]), code)[0];
      var secondArticle = detectSingle("Article ".concat(articles[1]), code)[0];
      return [_objectSpread({}, firstArticle || {}, {
        source: "articles ".concat(parts[1])
      }), _objectSpread({}, secondArticle || {}, {
        source: "".concat(parts[6])
      })];
    }

    var fullValueString = code ? "Articles ".concat(articles[0], " ").concat(operator, " ").concat(articles[1], " du ").concat(code.value) : "Articles ".concat(articles[0], " ").concat(operator, " ").concat(articles[1]);
    var url;

    if (code) {
      try {
        var codeData = require("../data/articles/".concat(code.id, ".json"));

        var id = codeData[articles[0]];

        if (id) {
          url = "https://www.legifrance.gouv.fr/affichCode.do?idArticle=".concat(id, "&cidTexte=").concat(code.id);
        }
      } catch (e) {
        console.log("e", e);
      }
    }

    return [{
      source: sourceString,
      fullValue: fullValueString,
      value: valueString,
      //article,
      code: code,
      url: url
    }];
  }).reduce(function (a, c) {
    return [].concat(_toConsumableArray(a), _toConsumableArray(Array.isArray(c) && c || [c]));
  }, []) || [];
};
/* find and normalize single article references
 *
 * Article D523
 * Article L523-2
 * Article L. 523-2-3-2
 * Article 45
 * Article * du code du commerce
 *
 */


var detectSingle = function detectSingle(str, defaultCode) {
  var matches = str.match(new RegExp(RE_ARTICLE, "gi"));
  var startIndex = 0;
  return matches && matches.map(function (match) {
    var indexOfArticle = str.indexOf(match, startIndex);
    var parts = match.match(new RegExp(RE_ARTICLE, "i"));
    var article = {
      source: match,
      value: "".concat(parts[1] || "").concat(parts[2])
    };
    var codeSearchString = getSubPhraseFromIndex(str, indexOfArticle + match.length);
    var detectedCode = detectCode(codeSearchString);
    var sourceString = detectedCode ? str.substring(indexOfArticle, indexOfArticle + "".concat(match, " du ").concat(detectedCode.source).length) : str.substring(indexOfArticle, indexOfArticle + match.length);
    var valueString = detectedCode ? "Article ".concat(article.value, " du ").concat(detectedCode.value) : "Article ".concat(article.value);
    var code = detectedCode || defaultCode;
    var fullValueString = code ? "Article ".concat(article.value, " du ").concat(code.value) : "Article ".concat(article.value);
    startIndex = indexOfArticle + match.length;
    var url;

    if (code) {
      try {
        var articles = require("../data/articles/".concat(code.id, ".json"));

        var id = articles[article.value];

        if (id) {
          url = "https://www.legifrance.gouv.fr/affichCodeArticle.do?idArticle=".concat(id, "&cidTexte=").concat(code.id);
        }
      } catch (e) {
        console.log("e", e);
      }
    }

    return {
      source: sourceString,
      fullValue: fullValueString,
      value: valueString,
      article: article,
      code: code,
      url: url
    };
  }) || [];
};

var detectArticles = function detectArticles(str, defaultCode) {
  return [].concat(_toConsumableArray(detectSingle(str, defaultCode)), _toConsumableArray(detectMultiples(str, defaultCode)));
};

module.exports = {
  detectSingle: detectSingle,
  detectMultiples: detectMultiples
};